import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import { FloatingActions, ReduxSelect } from 'components/FormElements'
// context
import { ObjectiveContext } from 'context'
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// hooks
import { useFieldAccess, useFormDirtyCount, useReviewFieldIds } from 'hooks'
// constants
import { OBJECT_ENTITY_NAMES } from 'constants/index'
// views
import { Collapse, Form } from 'components/Modals/PlanItems/styles'
// utils
import { generateFields } from 'utils/fields'

const DetailsForm = ({ form, handleSubmit, reset, isReadOnly }) => {
  const [isCollapsed, setExpanded] = React.useState(false)

  const { plan, entity, planTypeLevel, typeOptions, handleDetailsSubmit } = React.useContext(ObjectiveContext)
  const { isLinkingMode } = React.useContext(LinkingModeContext)

  const canViewRestricted = useFieldAccess(entity)
  const reviewFieldIds = useReviewFieldIds(OBJECT_ENTITY_NAMES.OBJECTIVE)

  const { dirtyFieldsCount } = useFormDirtyCount(form)

  const { objectiveModifyObjective, objectiveSetUserObjectiveSecurity } = entity.currentPermissions

  const canModify = !isReadOnly && !plan.locked && objectiveModifyObjective

  React.useEffect(() => {
    if (isLinkingMode) {
      setExpanded(true)
    }
  }, [isLinkingMode])

  return (
    <>
      <Collapse isCollapsed={isCollapsed} handleClick={() => setExpanded(!isCollapsed)}>
        {`About this ${planTypeLevel.description}`}
      </Collapse>
      {!isCollapsed && (
        <Form onSubmit={handleSubmit}>
          {typeOptions.length > 0 && (
            <ReduxSelect name='typeOption' label='Type' options={typeOptions} isDisabled={!canModify} />
          )}
          {entity.fields
            .filter((field) => field.name !== 'completionPercentage' && !reviewFieldIds.includes(field.id))
            .map((field) =>
              generateFields({
                field,
                form,
                canViewRestricted,
                canModify,
                canSetPermissions: !isReadOnly && objectiveSetUserObjectiveSecurity
              })
            )}
          <FloatingActions
            form={form}
            onCancel={reset}
            dirtyCount={dirtyFieldsCount}
            handleConfirm={handleDetailsSubmit}
          />
        </Form>
      )}
    </>
  )
}

export default reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true
})(DetailsForm)
